import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user\"><defs><style></style></defs><path d=\"M511.534 586.326c144.208 0 261.13-116.904 261.13-261.13 0-144.22-116.922-261.123-261.13-261.123-144.201 0-261.123 116.904-261.123 261.123 0 144.226 116.92 261.13 261.123 261.13zm209.268-22.815c-55.835 49.041-129.03 78.785-209.182 78.785-80.148 0-153.34-29.744-209.176-78.785-141.88 75.113-238.553 224.22-238.553 395.93h895.463c.001-171.71-96.678-320.817-238.552-395.93zm-.127 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol